import { render, staticRenderFns } from "./TwoItemField.vue?vue&type=template&id=18c21f87&scoped=true"
import script from "./TwoItemField.vue?vue&type=script&lang=js"
export * from "./TwoItemField.vue?vue&type=script&lang=js"
import style0 from "./TwoItemField.vue?vue&type=style&index=0&id=18c21f87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c21f87",
  null
  
)

export default component.exports